import gql from 'graphql-tag';

export const getUserEnrollmentsQuery = gql`
  query getUserEnrollments {
    getUserEnrollments {
      identifier
      message
      data {
        id
        enrollmentDate
        academicRecordId
        course {
          id
          name
          slug
          degreeType
        }
      }
    }
  }
`;

export const getDisciplineInstanceQuery = gql`
  query getDisciplineInstance($courseId: String!, $disciplineId: String!) {
    getDisciplineLessons(disciplineId: $disciplineId, courseId: $courseId) {
      identifier
      message
      data {
        id
        legacyId
        lessons {
          id
          name
          description
          slug
          type
          items {
            id
            title
            name
            typename
            dexArticleId
            dexExerciseId
            exerciseType
            videoName
            kalturaId
            youtubeId
            actualDurationInSeconds
          }
        }
        reviewLists {
          dexReviewListId
        }
      }
    }
  }
`;

export const getUserDisciplinesQuery = gql`
  query getUserDisciplines($courseId: String!) {
    getUserDisciplines(courseId: $courseId) {
      data {
        moduleId
        name
        displayName
        type
        disciplines {
          id
          name
          slug
          disciplineInstanceId
          isMigrated
          studyWindowId
        }
      }
      identifier
      message
    }
  }
`;

export const getDisciplinesForumChannel = gql`
  query getDisciplinesForumChannels(
    $courseId: String!
    $disciplines: [GetDisciplinesForumChannelsInput!]!
  ) {
    getDisciplinesForumChannels(courseId: $courseId, disciplines: $disciplines) {
      identifier
      message
      data {
        id
        name
      }
    }
  }
`;

export const getUserMicrocertificatesQuery = gql`
  query getUserMicrocertificates($submoduleIds: [String!]!) {
    getUserMicrocertificates(submoduleIds: $submoduleIds) {
      identifier
      message
      data {
        microcertificateId
        microcertificateName
        userMicrocertificateId
        submoduleId
      }
    }
  }
`;

export const getUserNotebookQuery = gql`
  query getUserNotebook($disciplineId: String) {
    getUserNotebook(disciplineId: $disciplineId) {
      identifier
      message
      data {
        discipline
        lessons {
          lesson
          videos {
            video
            notes {
              id
              platform
              video
              lesson
              disciplineId
              discipline
              videoTimeStamp
              originUrl
              latestText {
                markdownText
              }
              dexVideo
              dexLesson
              dexDiscipline
            }
          }
        }
        totalNotes
      }
    }
  }
`;

export const getUserVideoNotesQuery = gql`
  query getUserVideoNotes($videoId: String!, $isDisciplineMigrated: Boolean!) {
    getUserVideoNotes(videoId: $videoId, isDisciplineMigrated: $isDisciplineMigrated) {
      identifier
      message
      data {
        id
        profileId
        videoId
        lessonId
        disciplineId
        originUrl
        platform
        videoTimeStamp
        latestText {
          id
          markdownText
        }
        draft {
          id
          markdownText
        }
      }
    }
  }
`;

export const getNoteOriginUrlQuery = gql`
  query getNoteOriginUrl($note: GetNoteOriginUrlInput!) {
    getNoteOriginUrl(note: $note) {
      identifier
      message
      data
    }
  }
`;

export const getUserCalendarQuery = gql`
  query getUserCalendar {
    getUserCalendar {
      identifier
      message
      data {
        id
        userId
        status
        provider
        providerCalendarId
        providerUserId
        createdAt
        updatedAt
        subjects
      }
    }
  }
`;

export const getUserPendingDocsQuery = gql`
  query getUserPendingDocs {
    getUserPendingDocs {
      data {
        userPendingDocsResponse {
          courseId
          lyceumPendingDocs {
            obrigatorio
            status
          }
          errorMessage
        }
      }
      identifier
      message
    }
  }
`;
